import { performDraw, addTelemetryMetrics, noop, timeStampNow, elapsed } from '@datadog/browser-core';
const RECORDER_INIT_METRICS_TELEMETRY_NAME = 'Recorder init metrics';
export function startRecorderInitTelemetry(configuration, telemetry, observable) {
    const recorderInitTelemetryEnabled = telemetry.enabled && performDraw(configuration.replayTelemetrySampleRate);
    if (!recorderInitTelemetryEnabled) {
        return { stop: noop };
    }
    let startContext;
    let documentReadyDuration;
    let recorderSettledDuration;
    const { unsubscribe } = observable.subscribe((event) => {
        switch (event.type) {
            case 'start':
                startContext = { forced: event.forced, timestamp: timeStampNow() };
                documentReadyDuration = undefined;
                recorderSettledDuration = undefined;
                break;
            case 'document-ready':
                if (startContext) {
                    documentReadyDuration = elapsed(startContext.timestamp, timeStampNow());
                }
                break;
            case 'recorder-settled':
                if (startContext) {
                    recorderSettledDuration = elapsed(startContext.timestamp, timeStampNow());
                }
                break;
            case 'aborted':
            case 'deflate-encoder-load-failed':
            case 'recorder-load-failed':
            case 'succeeded':
                // Only send metrics for the first attempt at starting the recorder.
                unsubscribe();
                if (startContext) {
                    addTelemetryMetrics(RECORDER_INIT_METRICS_TELEMETRY_NAME, {
                        metrics: createRecorderInitMetrics(startContext.forced, recorderSettledDuration, elapsed(startContext.timestamp, timeStampNow()), event.type, documentReadyDuration),
                    });
                }
                break;
        }
    });
    return { stop: unsubscribe };
}
function createRecorderInitMetrics(forced, loadRecorderModuleDuration, recorderInitDuration, result, waitForDocReadyDuration) {
    return {
        forced,
        loadRecorderModuleDuration,
        recorderInitDuration,
        result,
        waitForDocReadyDuration,
    };
}
//# sourceMappingURL=startRecorderInitTelemetry.js.map